<div class="p-header">
  <a class="navbar-brand mr-1" routerLink="/app"><img src="../../../../assets/images/logo.png" alt="Cimalti"></a>

  <div class="portfolio-title">{{portfolio.name}}</div>
</div>
